import {HivTestAPIServiceApi, Configuration} from "./gen";
import axios from "axios";

export const grpcAPI = (function (){
    const authToken = localStorage.getItem("authToken");

    const instance = axios.create({
        headers: {
            'content-type': 'application/json',
            "authorization": (authToken === null ? "" : `Bearer ${authToken}`)
        }
    });
    return new HivTestAPIServiceApi(new Configuration(), window.location.origin, instance);
} as unknown) as {new ():HivTestAPIServiceApi}